import blGlobal from 'shared/javascripts/api/settings/blglobal';
import * as braze from '@braze/web-sdk';

const brazeConfig = {
  apiKey: process.env.BRAZE_API_KEY || '',
  sdkEndpoint: process.env.BRAZE_SDK_ENDPOINT || '',
  enableLogging: process.env.NODE_ENV === 'development',
};

const currentPlatform = () => {
  const userAgent = window.USER?.agent;

  if (!userAgent) return 'desktop';

  if (userAgent.isWebview && userAgent.isAndroid) return 'android';
  if (userAgent.isWebview && userAgent.isIphone) return 'iphone';
  if (userAgent.isMobile) return 'mobile_web';
  return 'desktop';
};

const BrazeTracker = {
  initialize: () => {
    const userId = window.USER ? window.USER.id36 : blGlobal.user.id36;

    if (brazeConfig.enableLogging) {
      braze.toggleLogging();
    }

    braze.initialize(brazeConfig.apiKey, {
      baseUrl: brazeConfig.sdkEndpoint,
    });

    // check if user id is exist
    // because user could access our page without login
    if (userId) {
      braze.changeUser(userId);
    }

    braze.openSession();

    return braze;
  },
  sendEvent(eventName, payload = {}) {
    if (!eventName) return;

    braze.logCustomEvent(eventName, {
      ...payload,
      platform: currentPlatform(),
    });
  },

  async sendImmediateEvent(eventName, payload = {}) {
    if (!eventName) return;

    braze.logCustomEvent(eventName, {
      ...payload,
      platform: currentPlatform(),
    });

    return new Promise((resolve, reject) => {
      braze.requestImmediateDataFlush((res) => {
        res ? resolve(res) : reject(res);
      });
    })
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  },
};

export default BrazeTracker;
